import { component } from 'picoapp'

export default component((node, ctx) => {
  const price = document.querySelectorAll('.js-update-price'); 
  const select = document.querySelector('[data-option-main]');
  const form = document.querySelector('.product-details form');

  form.addEventListener('change', function() {
    select.dispatchEvent(new Event('change'));
    // console.log('changed')
  })

  select.addEventListener('change', function() {
    setTimeout(function() {
      // console.log('recieve change')
      // console.log(select.options.[select.selectedIndex].dataset)
      const selectedPrice = select.options[select.selectedIndex].dataset.price
  
      // update prices on selector change
      for (let i = 0; i < price.length; i++) {
        const p = price[i];
        p.innerHTML = '$' + selectedPrice;
      }
    }, 550)
  })

  // update inner HTML


})